import {Form} from '@mintdata-wsp/common/components/form/Form';
import {IFormFieldState} from '@mintdata-wsp/common/components/formField/FormField';
import {Validators} from '@mintdata-wsp/common/components/validators/Validators';
import {ApiError} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {ResetPasswordEmailRequest} from '@mintdata-wsp/common/controllers/network/generated/requests/ResetPasswordEmailRequest';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {action} from 'mobx';

export class ResetPasswordController
{
    public init()
    {
    }

    @action
    public submitForm(form:Form)
    {
        const {resetPasswordPage} = rootState.ui;

        if (resetPasswordPage.isResetPasswordInProgress || !form.areAllFieldsValid() || form.areSomeFieldIsEmpty())
            return;

        let formData = form.getFormData();

        const email:string = formData.email as string;

        form.removeServerErrors();
        resetPasswordPage.isResetPasswordInProgress = true;

        const req = new ResetPasswordEmailRequest(email);

        // TODO remove debug ------------------------------
        // setTimeout(action(()=>{
        //     resetPasswordPage.isResetPasswordInProgress = false;
        //     resetPasswordPage.isEmailSent = true;
        //     // form.setServerErrors('error from server');
        // }), 4000);
        // return ;
        // TODO remove debug ------------------------------

        controllers.user.resetPassword(req)
        .then(action((response)=>
        {
            if (ApiError.isError(response))
            {
                throw (response as ApiError).message;
            }
            // TODO remove debug ------------------------------
            // setTimeout(action(()=>{

            resetPasswordPage.isEmailSent = true;
            resetPasswordPage.isResetPasswordInProgress = false;

            // TODO remove debug ------------------------------
            // }), 4000);
        }))
        .catch(action((err:string | any) =>
        {
            console.warn(err);
            // TODO remove debug ------------------------------
            // setTimeout(action(()=>{

            resetPasswordPage.isEmailSent = false;
            resetPasswordPage.isResetPasswordInProgress = false;

            let errorMessage = 'err';

            if (ApiError.isError(err))
                errorMessage = err.message;

            form.setServerErrors(errorMessage);

            // TODO remove debug ------------------------------
            // }), 4000);
        }));
    }

    public validateEmail(value:string, state:IFormFieldState<string>, form?:Form)
    {
        return Validators.validate({value, state, form},
            [
                Validators.emptyNotDirtyIsValid(),
                Validators.serverError('email'),
                Validators.email(),
            ]);
    }

}
